export const mapStyle = {
  width: '95%',
  height: '40vh',
  margin: '0 auto',          
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const defaultCenterMap = {
  lat: -36.606, // Chillán por defecto
  lng: -72.103,
};


export const defaultPoint:Point = {
  type: 'Point',
  coordinates: [defaultCenterMap.lng, defaultCenterMap.lat]
}

export const turnoMap: Record<string, string> = {
  M: 'mañana',
  T: 'tarde',
  N: 'noche',
};

export const  rolesMap: Record<string, string> = {
  USER: 'usuario',
  WORKER: 'trabajador',
  ADMIN: 'administrador'
};

export type Point = { type: 'Point'; coordinates: [number, number] }

export type CreateLocalidadDto = {
  name: string;
  location: Point;
};

export type Localidad = {
  id: string;
  name: string;
  location: Point;
};

export type Predio = {
  id: string;
  name: string;
  location: Point;
};

export type CreatePredioDto = {
  name: string;
  location: Point;
};

export interface PrediosPrograma extends Predio {
  usersM?: UserByDistance[];
  usersT?: UserByDistance[];
  usersN?: UserByDistance[];
}

export interface User {
  rut: string;
  name: string;
  apellido_paterno?: string;
  apellido_materno?: string;
  fecha_nacimiento?: string;
  sexo?:string;
  comuna?:string;
  provincia?:string;
  region?:string;
  estado_civil?:string;
  nivel_educacion?:string;
  numero_cargas?: number;
  afp?:string;
  no_calzado?: number;
  talla?:string;
  fecha_ingreso?: string;
  sueldo?: number;
  bonos?: number;
  phone?: string;
  email?: string;
  direccion?: string;
  cargo?: string;
  jornada?: string;
  contrato?: string;
  prevision?: string;
  password?: string;
  localidad: Localidad;
  is_active?: boolean;
  turno: string;
  organizations?: Organization[];
  roles?: { id: number; name: string }[];
};

export interface Organization {
  id: number;
  code: string;
  name: string;
  users?: { rut: string; name: string }[];
}

export interface CreateOrganizationDto {
  code: string;
  name: string;
}

export interface UpdateOrganizationDto {
  code?: string;
  name?: string;
}


export interface CreateUserDto{
  rut: string;
  name: string;
  apellido_paterno?: string;
  apellido_materno?: string;
  fecha_nacimiento?: string;
  sexo?:string;
  comuna?:string;
  provincia?:string;
  region?:string;
  estado_civil?:string;
  nivel_educacion?:string;
  numero_cargas?: number;
  afp?:string;
  no_calzado?: number;
  talla?:string;
  fecha_ingreso?: string;
  sueldo?: number;
  bonos?: number;
  phone?: string;
  email?: string;
  direccion?: string;
  cargo?: string;
  jornada?: string;
  contrato?: string;
  prevision?: string;
  password?: string;
  localidad?: string;
  turno: string;
  is_active?: boolean;
  organization?: string;
};

export interface UserBasic extends UserBasicUpdate {
  rut: string;
}
export interface UserBasicUpdate {
  nombre: string;
  cargo?: string;
  zona?: string;
  correo?: string;
}



export interface RegisterUserDto{
  rut: string;
  name: string;
  email: string;
  organization: string;
}

export type UserByDistance = {
  rut: string;
  name: string;
  phone: string;
  email: string;
  localidad: string;
  distance: number;
  turno: string
};


export type FilterUsersDto = {
  excludeUsers: string[];
  role: string[];
  turno: string[];
  localidad: string[];
  organization?: string[];
}

export type Programa = {
  fecha: string;
  detalles: string;
  prediosPrograma: PrediosPrograma[];
};

export interface ProgramaDetails extends Programa {
  id: string
};

// Tipos de datos
export interface FormField {
  id: string;
  label: string;
  type: string;
  options?: string[];
  required: boolean;
  sendMailCondition?: string;
  sendMail?: boolean;
  distributionList?: string[];
  /** Orden de la pregunta dentro del formulario (lo fija la posición en la UI del builder). */
  orden?: number;
}

export interface FormPayload {
  id: string;
  name: string;
  organization: string;
  isSignRequired: boolean;
  fields: FormField[];
  distributionList?: string[];
  users?: User[];
}

export interface CreateFormDto {
  name: string;
  isSignRequired: boolean;
  fields: Omit<FormField, 'id'>[]; // el backend genera los UUID
  distributionList?: string[];
}

// Tipos de datos
export interface SubmissionValue {
  fieldId: string;
  value: string;
  note?: SubmissionNotes;
}

// notas
export interface SubmissionNotes {
  noteText: string;
  imageUrl?: string;
  location?: string;
  imageBase64?: string;
}
// notas
export interface NotesResponse {
  note_text: string;
  image_url: string;
  location?: string;
}

export interface CreateSubmissionDto {
  signature: string;
  zona?: string;
  mail?: string;
  rut?: string;
  values: SubmissionValue[];
  notes: SubmissionNotes[];
}

export interface FormSubmission {
  id: string;
  formId: string;
  signature: string;
  submittedAt: string;
  rut?: string;
  values: {
    id: string;
    fieldId: string;
    value: string;
  }[];
  notes?:NotesResponse[];
}

export interface CreateDistributionList {
  name: string;
  organization: string;
  users?: any[];
  usersBasic?: any[];
}

export interface UpdateDistributionListDto extends CreateDistributionList {}

export interface DistributionList extends CreateDistributionList {
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HojaDeVida {
  id: string;
  userRut: string;
  createdAt: string;
  fecha: string;
  texto: string;
}

export interface CreateHojaDeVidaDto {
  user_rut: string;
  fecha: string;
  texto: string;
}